import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

loadFonts()

// --------------------------------------------------------
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
// --------------------------------------------------------
// ------------- load firebase configuration ------------------
import {firebaseConfig} from "../config_nas"
// -------------------------------------------------------------------

export const firebase_app = initializeApp(firebaseConfig);
const fb_firestoreDB = getFirestore(firebase_app);
const fb_storage = getStorage(firebase_app);
const fb_funcs = getFunctions(firebase_app, 'asia-southeast1');
const fb_analytics = getAnalytics(firebase_app); // Google Analytics
export { fb_firestoreDB, fb_storage, fb_analytics, fb_funcs };

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')


  // manual process to update video embeding from CKEditor to iFrame
  export function update_video_tag(html_content){
    let new_html_content = html_content
    if(html_content.includes(`<oembed url="https://www.youtube.com/embed/`)){
      //  - Currently only support Youtube video
      new_html_content = new_html_content.replace(`<oembed url="https://www.youtube.com/embed/`, `<iframe class="responsive-iframe" src="https://www.youtube.com/embed/`)
      new_html_content = new_html_content.replace(`></oembed>`, ` title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`)
    }
    return new_html_content
  }